module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_2.fc5f218b.png";